export default __webpack_public_path__ + "static/media/mmult.ba091692.png";